// extracted by mini-css-extract-plugin
export default {"header":"main_header__usmG0","sidebar1":"main_sidebar1__L-vwB","sidebar2":"main_sidebar2__VQaOD","content":"main_content__zxqsF"};